// eslint-disable-next-line import/prefer-default-export
export const passwordStrength = {
  none: 'none',
  low: 'low',
  medium: 'medium',
  safe: 'safe',
};

// eslint-disable-next-line import/prefer-default-export
export const companyServicesOptions = {
  VulnerabilityAssessment: 'VulnerabilityAssessment',
  PenetrationTesting: 'Penetration Testing',
  SecurityCodeReview: 'Security Code Review',
  InfrastructureSecurityAudit: 'Infrastructure Security Audit',
  ComplianceSecureAndRegulationAudit: 'Compliance Secure And Regulation Audit',
  ApplicationSecureArchitecture: 'Application Secure Architecture',
  ThreatHunting: 'Threat Hunting',
};

export const spWorkerWorkingDays =
  [
    { value: 'Sunday', title: 'S'},
    { value: 'Monday', title: 'M'},
    { value: 'Tuesday', title: 'T'},
    { value: 'Wednesday', title: 'W'},
    { value: 'Thursday', title: 'T'},
    { value: 'Friday', title: 'F'},
    { value: 'Saturday', title: 'S'},
  ];
